import { MAKKAH_PERMISSIONS_FULL_NAMES, MADINAH_PERMISSIONS_FULL_NAMES } from "@/utils/constants";
import usePermissions from "@/utils/hooks/usePermissions";
import { useSystem } from "@/utils/hooks/useLocation";

/**
 * Nusuk cards permissions for the active city system (Makkah vs Madinah).
 * Backend permission names are shared; system prefix differs (1_ vs 2_).
 */
export function useNusukCardsPermissions() {
  const { currentSystem } = useSystem();
  const { hasPermissionByName, hasAnyPermission } = usePermissions();
  const full =
    currentSystem === "madina" ? MADINAH_PERMISSIONS_FULL_NAMES : MAKKAH_PERMISSIONS_FULL_NAMES;

  return {
    canListBatches: hasPermissionByName(full.list_nusuk_cards_batchs),
    canViewBatch: hasPermissionByName(full.view_nusuk_cards_batchs),
    canCreateBatch: hasPermissionByName(full.create_nusuk_cards_batchs),
    canUpdateBatch: hasPermissionByName(full.update_nusuk_cards_batchs),
    canDeleteBatch: hasPermissionByName(full.delete_nusuk_cards_batchs),
    canChangeDeliveryStatus: hasPermissionByName(full.change_delivery_status_nusuk_cards_batchs),
    canListReturns: hasPermissionByName(full.list_nusuk_cards_batch_returns),
    canCreateReturn: hasPermissionByName(full.create_nusuk_cards_batch_returns),
    canUpdateReturn: hasPermissionByName(full.update_nusuk_cards_batch_returns),
    canDeleteReturn: hasPermissionByName(full.delete_nusuk_cards_batch_returns),
    canViewExportBatchReport: hasPermissionByName(full.view_export_nusuk_cards_batch_report),
    canListIncidentReports: hasPermissionByName(full.list_nusuk_cards_batchs_incident_reports),
    canResolveIncidentReports: hasPermissionByName(full.resolve_nusuk_cards_batchs_incident_reports),
    /** Open batch details from list (list or view permission). */
    canOpenBatchDetails: hasAnyPermission([full.list_nusuk_cards_batchs, full.view_nusuk_cards_batchs]),
  };
}
